import NextImage from 'next/legacy/image';
import { Image as DatoImage } from 'react-datocms';
import type { ImageFragment } from '@/utils/dato/generated';

const Image = ({ imageFile }: ImageFragment) => (
  <div className="image-block mb-5">
    {imageFile?.responsiveImage ? (
      <DatoImage data={imageFile?.responsiveImage} style={{ margin: '0 auto' }} />
    ) : imageFile?.url ? (
      <NextImage
        alt={imageFile?.title || 'Link With an image'}
        height={imageFile.height || undefined}
        width={imageFile.width || undefined}
        src={imageFile.url}
      />
    ) : null}
  </div>
);

export default Image;
